<div class="cFull">
  <app-header></app-header>
  <div class="content">
    <div class="sidebar" id="sidebar">
      <app-sidebar></app-sidebar>
    </div>
    <section class="rSide" id="rSide">
      <div class="bread">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <router-outlet></router-outlet>
    </section>
  </div>
</div>
<div class="footer">
  <app-chubb-footer></app-chubb-footer>
</div>
